import { http, type PathParams } from "msw";

import { isoNow } from "@/mocks/dates";
import { withSession } from "@/mocks/resolvers";
import { successResponse } from "@/mocks/responses";

type NotificationPreferencesRequest = {
  sms_enabled: boolean;
  emails_enabled: boolean;
};

const toggleTimestamp = (enabled: boolean, currentTimestamp: string | null) => {
  if (!enabled) {
    return null;
  }

  return currentTimestamp ?? isoNow();
};

export const createProfileHandlers = (webappUrl: string) => {
  return [
    http.get(
      `${webappUrl}/me`,
      withSession(({ state }) => {
        return successResponse(state.profile);
      }),
    ),

    http.patch(
      `${webappUrl}/notifications`,
      withSession<PathParams, NotificationPreferencesRequest>(async ({ request, state }) => {
        const { emails_enabled, sms_enabled } = await request.json();

        state.profile.smsEnabledAt = toggleTimestamp(sms_enabled, state.profile.smsEnabledAt);
        state.profile.emailsEnabledAt = toggleTimestamp(
          emails_enabled,
          state.profile.emailsEnabledAt,
        );
        state.profile.sms_communication_permissions = sms_enabled;

        return successResponse(state.profile);
      }),
    ),

    http.get(
      `${webappUrl}/pending-actions`,
      withSession(({ state }) => {
        return successResponse(state.pendingActions);
      }),
    ),
  ];
};
